/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ValidateBankAccountRequest as ModelsV3LoanManagementValidateBankAccountRequest } from '../../models/Models/v3/LoanManagement/validate-bank-account-request';
import { ValidateBankAccountResponseBaseResponse as ModelsV3LoanManagementValidateBankAccountResponseBaseResponse } from '../../models/Models/v3/LoanManagement/validate-bank-account-response-base-response';

export interface V3LoanManagementValidateBankAccountPost$Xml$Xml$Params {
      body?: ModelsV3LoanManagementValidateBankAccountRequest
}

export function v3LoanManagementValidateBankAccountPost$Xml$Xml(http: HttpClient, rootUrl: string, params?: V3LoanManagementValidateBankAccountPost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementValidateBankAccountResponseBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v3LoanManagementValidateBankAccountPost$Xml$Xml.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+xml');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV3LoanManagementValidateBankAccountResponseBaseResponse>;
    })
  );
}

v3LoanManagementValidateBankAccountPost$Xml$Xml.PATH = '/v3/loan-management/validate-bank-account';
